import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { axiosAiInstance } from '../../utils/axios';
import { dispatch } from '../store';
import { rejectWithError } from '../dispatchError';
import { translator } from 'translation/useTranslator';

export type TenantTokenUsage = {
  tenantId: string;
  promptCount: number;
  totalInputTokens: number;
  totalOutputTokens: number;
  totalTokens: number;
};

type AiTokenUsageState = {
  isLoading: boolean;
  tenants: TenantTokenUsage[];
};

const initialState: AiTokenUsageState = {
  isLoading: false,
  tenants: []
};

const slice = createSlice({
  name: 'aiTokenUsage',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    getAiTokenUsageSuccess(state, action: PayloadAction<TenantTokenUsage[]>) {
      state.tenants = action.payload;
      state.isLoading = false;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export function getAiTokenUsage() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosAiInstance.get('token-usage-logs');
      dispatch(slice.actions.getAiTokenUsageSuccess(response.data?.tenants ?? []));
      return await Promise.resolve({
        result: response,
        defaultSuccessMessage: translator?.aiUsageFetched() ?? 'AI feedback usage fetched'
      });
    } catch (error) {
      dispatch(slice.actions.stopLoading());
      return await rejectWithError({
        error,
        defaultErrorMessage: translator?.aiUsageFetchFailed() ?? 'Could not fetch AI feedback usage'
      });
    }
  };
}
